var _rect, _rect2, _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    rx: 4,
    fill: "#148EFF",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1081_24719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1081_24719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 16,
    width: 58,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.9852 16.5078H137.165V80.0376H80.9852V16.5078Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1081_24719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.016 79.9091C124.465 79.9091 137.032 62.543 137.032 46.182C137.032 29.8211 124.465 16.5078 109.016 16.5078C93.5663 16.5078 80.998 29.8211 80.998 46.182C81.0004 62.5418 93.5675 79.9091 109.016 79.9091Z",
    fill: "#148EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1081_24719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 80,
    width: 106,
    height: 59
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5852 80.2031H161.415V138.742H56.5852V80.2031Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1081_24719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.049 80.2188C124.615 84.6039 117.835 87.2127 110.491 87.2127H107.541C100.197 87.2127 93.4152 84.6027 87.9824 80.2188C70.2372 83.2565 56.6864 99.5458 56.6864 119.195C56.6864 129.989 80.115 138.742 109.016 138.742C137.917 138.742 161.346 129.989 161.346 119.195C161.346 99.5458 147.795 83.2565 130.049 80.2188Z",
    fill: "#148EFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_24719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 107,
    fill: "white",
    transform: "translate(48 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.bce13c8184ff590dccab133d84cf33af.svg";
export { ForwardRef as ReactComponent };